'use client';

import { differenceInMilliseconds } from 'date-fns';
import { createContext, useEffect, useState } from 'react';
import { refreshToken } from './login-methods';
import { Session } from './session';

const TokenContext = createContext<Session | null>(null);

export function SessionProvider({
  children,
  session,
}: {
  children: React.ReactNode;
  session: Session;
}) {
  const [activeSession, setActiveSession] = useState<Session | null>(session);
  useEffect(() => {
    if (session.authenticated) {
      const expire = new Date(session.expire);
      const current = new Date();
      const sessionExpiresInMs = differenceInMilliseconds(expire, current);
      const threshold = 2 * 60 * 1000;

      const timeout = setTimeout(async () => {
        setActiveSession(await refreshToken());
      }, sessionExpiresInMs - threshold);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [session]);

  return <TokenContext value={activeSession}>{children}</TokenContext>;
}
